import $api from "http/index";

export const listSyllabuses = (params) => $api.get("syllabus-builder/", { params });
export const getSyllabus = (id) => $api.get(`syllabus-builder/${id}/`);
export const createSyllabus = (data) => $api.post("syllabus-builder/", data);
export const updateSyllabus = (id, data) => $api.patch(`syllabus-builder/${id}/`, data);
export const deleteSyllabus = (id) => $api.delete(`syllabus-builder/${id}/`);
export const builderView = (id) => $api.get(`syllabus-builder/${id}/builder/`);
export const builderSave = (id, data) => $api.post(`syllabus-builder/${id}/builder-save/`, data);
export const cloneSyllabus = (id, data) => $api.post(`syllabus-builder/${id}/clone/`, data || {});
export const submitReview = (id) => $api.post(`syllabus-builder/${id}/submit-review/`);
export const approveSyllabus = (id) => $api.post(`syllabus-builder/${id}/approve/`);
export const archiveSyllabus = (id) => $api.post(`syllabus-builder/${id}/archive/`);
export const compareSyllabuses = (id, withId) =>
  $api.get(`syllabus-builder/${id}/compare/`, { params: { with: withId } });

export const listPlanTemplates = (params) => $api.get("plan-templates/", { params });
export const applyPlanTemplate = (id, data) => $api.post(`plan-templates/${id}/apply/`, data);

export const listThemeMaterials = (params) => $api.get("theme-materials/", { params });
export const createThemeMaterial = (data) => {
  const fd = new FormData();
  Object.entries(data).forEach(([k, v]) => {
    if (v !== undefined && v !== null) fd.append(k, v);
  });
  return $api.post("theme-materials/", fd);
};
export const updateThemeMaterial = (id, data) => $api.patch(`theme-materials/${id}/`, data);
export const deleteThemeMaterial = (id) => $api.delete(`theme-materials/${id}/`);

export const SYLLABUS_STATUSES = [
  { value: "draft", label: "Черновик" },
  { value: "review", label: "На рассмотрении" },
  { value: "approved", label: "Утверждён" },
  { value: "archived", label: "Архивный" },
];
